<template>
  <div class="md:py-12 lg:py-12 py-6 relative">
    <div class="absolute top-1/2 left-20 md:block lg:block hidden">
      <img
        src="../../../assets/images/bg-des/elli.svg"
        alt="ellipsis"
        class=""
      />
    </div>
    <div class="absolute -bottom-1/4 left-0 md:block lg:block hidden">
      <img
        src="../../../assets/images/bg-des/open-posi-tri.svg"
        alt="ellipsis"
        class=""
      />
    </div>
    <div class="w-full mx-auto relative">
      <div class="absolute top-0 right-10 md:block lg:block hidden">
        <img
          src="../../../assets/images/bg-des/elli.svg"
          alt="ellipsis"
          class=""
        />
      </div>

      <p class="title-semibold fsize36-24px">Internship Positions</p>
      <p class="subtitle lh32px md:pt-6 lg:pt-6 pt-4 sm-fsize13 sm-lh26">
        An internship with us is an opportunity for any adult to experience and
        learn about the workings and challenges of a start-up in a
        social-healthcare sector. Interns will not only be mentored on the
        entire operations of the organization, but will also get to build their
        careers through diverse learning opportunities. We welcome anyone who is
        about to start a new career or is switching over from another one.
      </p>
      <ul class="pt-4 md:pl-6 lg:pl-6 pl-4 subtitle lh32px sm-fsize13 sm-lh26">
        <li class="pt-1">Are available to work full time</li>
        <li class="pt-1">Ready to join immediately.</li>
        <li class="pt-1">
          Are able to commit for a minimum duration of 3 months
        </li>
        <li class="pt-1">Have relevant skills and interests</li>
      </ul>
      <!-- <a
        href="https://forms.office.com/r/Nq2ACSFPFu "
      > -->
      <base-button
        type="primary"
        class="px-12 mt-5 py-2 fs16700 border-2"
        @click="handleRoute('request-form', 'work-at-cgs-as-internships')"
        >Apply Now</base-button
      >
      <!-- </a> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  methods: {
    handleClick(name, careerData) {
      this.$store.commit("cms/SET_SELECTED_CAREER", careerData);
      this.$router.push({ name: name });
      // this.toggleNavbar();
    },
    async getCareers() {
      await this.$store.dispatch("cms/getCareers");
      // console.log(this.careers);
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
  mounted() {
    this.getCareers();
  },
  computed: {
    ...mapState("cms", ["careers"]),
  },
};
</script>
<style scoped>
ul {
  list-style: disc;
}
</style>
